/* ═══════════════════════════════════════════════
   東京Lily — 商品詳細（PDP）
   - ギャラリー: サムネイルクリックでメイン切替（P-03）、メインクリックで簡易拡大（P-02）
   - バリエーションカード（P-10/F-2）: 選択でメイン画像切替（400ms以内）・URLに ?variant= 反映・価格更新
   - 数量UI＋Ajaxカート追加（T-410相当）: /cart/add.js → ヘッダー #tl-cart-count 更新
   - 販売期間カウントダウン（P-09/F-3）: エポック秒基準（表示文字列はサーバー側でJST整形済）
═══════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('tlPdp');
  if (!root) return;

  /* 2026-10-11 依頼7: 絵文字「🛒」は文字色が効かないため、ヘッダーのカートと同じ線画アイコン（stroke: currentColor）にする */
  var CART_LABEL = '<svg class="pdp-cta-ico" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 7h12l-1.5 12h-9L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span>カートに入れる</span>';

  /* ─────────── ギャラリー ─────────── */
  var mainWrap = document.getElementById('tlPdpMainImg');
  var mainImg = document.getElementById('tlPdpMainImgI');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));

  /* バリアント画像を持たないバリアント選択時のフォールバック用に初期メイン画像を記憶 */
  var defaultImage = null;
  if (mainImg && mainImg.tagName === 'IMG') {
    defaultImage = {
      src: mainImg.getAttribute('src'),
      zoom: mainImg.getAttribute('data-zoom')
    };
  }

  /* メイン画像切替。プリロード完了 or 350ms のどちらか早い方で必ず切替（要件: 400ms以内） */
  function swapMain(src, zoom) {
    if (!mainWrap || !mainImg || mainImg.tagName !== 'IMG' || !src) return;
    if (mainImg.getAttribute('src') === src) return;
    mainWrap.classList.add('changing');
    var applied = false;
    function apply() {
      if (applied) return;
      applied = true;
      mainImg.setAttribute('src', src);
      if (zoom) mainImg.setAttribute('data-zoom', zoom);
      mainWrap.classList.remove('changing');
    }
    var pre = new Image();
    pre.onload = function () {
      /* 画像本来の縦横比を維持するため width/height 属性も更新 */
      if (pre.naturalWidth && pre.naturalHeight) {
        mainImg.setAttribute('width', pre.naturalWidth);
        mainImg.setAttribute('height', pre.naturalHeight);
      }
      apply();
    };
    pre.onerror = apply;
    pre.src = src;
    setTimeout(apply, 350);
  }

  function activateThumb(matchFn) {
    thumbs.forEach(function (t) { t.classList.toggle('active', !!matchFn(t)); });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      activateThumb(function (x) { return x === t; });
      swapMain(t.getAttribute('data-full'), t.getAttribute('data-zoom'));
    });
  });

  /* ─────────── 簡易拡大（ライトボックス） ─────────── */
  var lb = document.getElementById('tlPdpLightbox');
  var lbImg = document.getElementById('tlPdpLightboxImg');
  if (mainWrap && lb && lbImg) {
    var openLb = function () {
      if (!mainImg || mainImg.tagName !== 'IMG') return; /* プレースホルダー時は何もしない */
      lbImg.src = mainImg.getAttribute('data-zoom') || mainImg.getAttribute('src');
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    };
    var closeLb = function () {
      lb.classList.remove('open');
      document.body.style.overflow = '';
    };
    mainWrap.addEventListener('click', openLb);
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(); }
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('pdp-lightbox-close')) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('open')) closeLb();
    });
  }

  /* ─────────── バリエーション ─────────── */
  var variants = [];
  var dataEl = document.querySelector('[data-tl-pdp-variants]');
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  }
  var priceVaries = root.getAttribute('data-price-varies') === 'true';
  var priceEl = document.getElementById('tlPdpPrice');
  var varCurrent = document.getElementById('tlPdpVarCurrent');
  var cartBtn = document.getElementById('tlPdpAddToCart');
  var varCards = Array.prototype.slice.call(document.querySelectorAll('.pdp-var-card'));

  function findVariant(id) {
    id = String(id);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  function renderPrice(v) {
    if (!priceEl || !v) return;
    var html = '';
    if (v.compare) html += '<span class="pdp-price-was">¥' + v.compare + '</span>';
    html += '<small>¥</small>' + v.price;
    if (priceVaries && v.isMin) html += '<small>〜</small>';
    priceEl.innerHTML = html;
  }

  function selectVariant(id) {
    var v = findVariant(id);
    if (!v) return;

    varCards.forEach(function (c) {
      c.classList.toggle('active', c.getAttribute('data-variant-id') === String(v.id));
    });
    if (varCurrent) varCurrent.textContent = v.title;
    renderPrice(v);

    /* 残り在庫（在庫管理ありのバリアントのみ） */
    var stockEl = document.getElementById('tlPdpStock');
    var stockNum = document.getElementById('tlPdpStockNum');
    if (stockEl && stockNum) {
      var hasStock = v.stock != null && v.stock > 0 && v.purchasable;
      stockEl.hidden = !hasStock;
      if (hasStock) stockNum.textContent = v.stock;
    }

    /* バリアント画像に切替＋対応サムネイルをアクティブ化（画像なしバリアントは初期メイン画像に戻す） */
    if (v.image) {
      swapMain(v.image, v.imageZoom);
      activateThumb(function (t) { return t.getAttribute('data-image-id') === String(v.imageId); });
    } else if (defaultImage && defaultImage.src) {
      swapMain(defaultImage.src, defaultImage.zoom);
      activateThumb(function (t) { return t.getAttribute('data-full') === defaultImage.src; });
    }

    /* カートボタン状態 */
    if (cartBtn) {
      cartBtn.setAttribute('data-variant-id', String(v.id));
      cartBtn.disabled = !v.purchasable;
      cartBtn.classList.remove('is-added');
      if (v.purchasable) cartBtn.innerHTML = CART_LABEL;
      else cartBtn.textContent = v.available ? '販売期間外' : '売り切れ';
    }

    /* URL に ?variant= を反映 */
    if (window.history && window.history.replaceState && window.URL) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    }
  }

  varCards.forEach(function (c) {
    c.addEventListener('click', function () {
      selectVariant(c.getAttribute('data-variant-id'));
    });
  });

  /* ─────────── 数量UI ─────────── */
  var qtyInput = document.getElementById('tlPdpQty');
  Array.prototype.forEach.call(document.querySelectorAll('[data-tl-qty]'), function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var delta = parseInt(btn.getAttribute('data-tl-qty'), 10) || 0;
      var v = parseInt(qtyInput.value, 10) || 1;
      v = Math.max(1, Math.min(99, v + delta));
      qtyInput.value = v;
    });
  });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, Math.min(99, v));
    });
  }

  /* ─────────── Ajaxカート追加（T-410相当） ─────────── */
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      if (cartBtn.disabled) return;
      var id = parseInt(cartBtn.getAttribute('data-variant-id'), 10);
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!id) return;

      cartBtn.disabled = true;
      cartBtn.textContent = '追加しています…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (json) {
              throw new Error(json.description || json.message || 'カートに追加できませんでした');
            });
          }
          return res.json();
        })
        .then(function () {
          /* ヘッダーのカート数を更新 */
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var count = document.getElementById('tl-cart-count');
              if (count) {
                count.textContent = cart.item_count;
                count.style.display = cart.item_count > 0 ? '' : 'none';
              }
            });
        })
        .then(function () {
          cartBtn.classList.add('is-added');
          cartBtn.textContent = '✓ カートに追加しました';
          setTimeout(function () {
            cartBtn.classList.remove('is-added');
            cartBtn.innerHTML = CART_LABEL;
            cartBtn.disabled = false;
          }, 2400);
        })
        .catch(function (err) {
          cartBtn.innerHTML = CART_LABEL;
          cartBtn.disabled = false;
          window.alert(err.message || 'カートに追加できませんでした');
        });
    });
  }

  /* ─────────── 販売期間カウントダウン（P-09/F-3） ───────────
     data-start / data-end はエポック秒（タイムゾーン非依存）。
     表示中の日時文字列は Liquid がショップタイムゾーン（JST）で整形済み。 */
  var period = document.getElementById('tlPdpPeriod');
  if (period) {
    var startE = parseInt(period.getAttribute('data-start'), 10) || 0;
    var endE = parseInt(period.getAttribute('data-end'), 10) || 0;
    var labelBase = period.getAttribute('data-label') || 'Sale Period';
    var statusEl = period.querySelector('[data-cd-status]');
    var wrapEl = period.querySelector('[data-cd-wrap]');
    var dEl = period.querySelector('[data-cd-d]');
    var hEl = period.querySelector('[data-cd-h]');
    var mEl = period.querySelector('[data-cd-m]');
    var sufEl = period.querySelector('[data-cd-suffix]');
    var barEl = period.querySelector('[data-cd-bar]');

    var tick = function () {
      var now = Math.floor(Date.now() / 1000);
      var target = 0;
      var suffix = '残り';
      var status = '受付中';

      if (endE && now > endE) {
        status = '販売終了';
        period.classList.add('is-ended');
      } else if (startE && now < startE) {
        status = '販売開始前';
        target = startE;
        suffix = '開始まで';
      } else if (endE) {
        target = endE;
      }

      if (statusEl) statusEl.textContent = labelBase + ' — ' + status;
      if (wrapEl) wrapEl.style.display = target ? '' : 'none';

      if (target) {
        var diff = Math.max(0, target - now);
        if (dEl) dEl.textContent = Math.floor(diff / 86400);
        if (hEl) hEl.textContent = Math.floor((diff % 86400) / 3600);
        if (mEl) mEl.textContent = Math.floor((diff % 3600) / 60);
        if (sufEl) sufEl.textContent = suffix;
      }

      if (barEl && startE && endE > startE) {
        var pct = ((now - startE) / (endE - startE)) * 100;
        pct = Math.min(100, Math.max(0, pct));
        barEl.style.width = pct + '%';
      }
    };

    tick();
    setInterval(tick, 30000);
  }
})();
